import * as types from '../constants/ActionTypes';

// eslint-disable-next-line import/prefer-default-export
export function ssoError(error) {
  return { error, type: types.SSO_ERROR };
}
